var router = [{
  "id": 1,
  "name": "首页配置",
  "path": "",
  "children": [{
    "id": 2,
    "name": "公告分类",
    "path": "/indexDisposition/announceType"
  }, {
    "id": 3,
    "name": "公告列表",
    "path": "/indexDisposition/announceList"
  }, {
    "id": 4,
    "name": "轮播图",
    "path": "/indexDisposition/topBanner"
  }, {
    "id": 5,
    "name": "社交渠道",
    "path": "/indexDisposition/socialChannel"
  }, {
    "id": 6,
    "name": "下载地址",
    "path": "/indexDisposition/downloadAddress"
  }, {
    "id": 7,
    "name": "落地页",
    "path": "/indexDisposition/landingPage"
  }, {
    "id": 8,
    "name": "充值官网配置",
    "path": "/indexDisposition/rechargeConfig"
  }]
}];
export default router;